module.exports = __webpack_public_path__ + "img/security-of-platform.4196853e.png";